import { render, staticRenderFns } from "./SnackBarComponent.vue?vue&type=template&id=8161876e"
import script from "./SnackBarComponent.vue?vue&type=script&lang=js"
export * from "./SnackBarComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports